<template>
    <div v-if="showInfoModal" class="qr-scanner-wrapper">
        <qrcode-stream @detect="onQRDetected"
                       @init="onInit"
                       :camera="cameraState"
                       :track="selected.value"
                       id="qr_scanner"
        >
        </qrcode-stream>

        <div class="content">
            <div class="qr-actions" v-if="checkQR">
                <div class="abtn negative" @click="onRescanClick">RESCAN</div>
                <div class="abtn positive" @click="onConfirmClick">CONFIRM</div>
            </div>

<!--            <div class="scanned">
                <div v-for="(qr) in qrs">{{ qr }}</div>
            </div>-->
            <div class="abtn" @click="onSaveClick">{{ this.qrs.length == 0 ? 'Close camera' : 'Finish adding QRs (' + this.qrs.length + ')'}}</div>
<!--            <div class="abtn">Cancel</div>-->
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import errorMixin from '@/mixins/errorMixin';
import {mapMutations, mapState} from "vuex";
import {QrcodeStream} from "vue-qrcode-reader";

export default {
    name: 'customModalDialog',
    components: {
        QrcodeStream,
    },

    mixins: [errorMixin],

    data() {
        return {
            showInfoModal: !_.isEmpty(this.settings),
            cameraState: 'rear',
            selected: { text: 'outline', value: this.paintOutline },
            checkQR: null,
            qrs: [],
        }
    },

    watch: {
        settings(newValue) {
            this.showInfoModal = !_.isEmpty(newValue)
        }
    },

    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
    },

    computed: {
        ...mapState({}),


    },

    methods: {

        ...mapMutations({}),


        paintOutline(detectedCodes, ctx) {
            for (const detectedCode of detectedCodes) {
                const [firstPoint, ...otherPoints] = detectedCode.cornerPoints

                ctx.strokeStyle = 'red'
                ctx.lineWidth = 10

                ctx.beginPath()
                ctx.moveTo(firstPoint.x, firstPoint.y)
                for (const { x, y } of otherPoints) {
                    ctx.lineTo(x, y)
                }
                ctx.lineTo(firstPoint.x, firstPoint.y)
                ctx.closePath()
                ctx.stroke()
            }
        },

        async onInit(promise) {
            try {
                const { capabilities } = await promise

            } catch (error) {
                if (error.name === 'NotAllowedError') {
                    // user denied camera access permisson
                } else if (error.name === 'NotFoundError') {
                    // no suitable camera device installed
                } else if (error.name === 'NotSupportedError') {
                    // page is not served over HTTPS (or localhost)
                } else if (error.name === 'NotReadableError') {
                    // maybe camera is already in use
                } else if (error.name === 'OverconstrainedError') {
                    // did you requested the front camera although there is none?
                } else if (error.name === 'StreamApiNotSupportedError') {
                    // browser seems to be lacking features
                }
            } finally {
                // hide loading indicator
            }
        },

        async onQRDetected(data) {
            console.log(`qrScanned:`, data)
            let dataObj = await data
            let content = dataObj.content
            console.log(`content:`, content)
            this.checkQR = dataObj
            this.pauseCamera()
        },

        pauseCamera() {
            this.cameraState = 'off'
        },
        continueCamera() {
            this.cameraState = 'rear'
        },

        onConfirmClick() {
            if(this.checkQR) {
                if(this.qrs.includes(this.checkQR.content)) {
                    this.showErrorModal("QR is already added", {duration: 1000})
                } else {
                    this.qrs.push(this.checkQR.content)
                }
            }
            this.checkQR = null
            this.continueCamera()
        },

        onRescanClick() {
            this.checkQR = null
            this.continueCamera()
        },

        async onSaveClick() {
            console.log(`onSaveClick`)
            this.showInfoModal = false
            if (this.settings.onFinishHandler) {
                try {
                    await this.settings.onFinishHandler(this.qrs)
                    // await this.settings.onFinishHandler(["1", "2"])

                    this.qrs = []
                    this.checkQR = null
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },

        async onClose() {
            this.showInfoModal = false
            if (this.settings.onCancelHandler) {
                try {
                    await this.settings.onCancelHandler(this.settings)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },

        async onOk() {
            this.showInfoModal = false
            if (this.settings.onOkHandler) {
                try {
                    await this.settings.onOkHandler(this.settings)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },

        onAdditional() {
            this.showInfoModal = false
            if (this.settings.onAdditionalHandler) {
                this.settings.onAdditionalHandler(this.settings)
            }
        },

    },
}
</script>

<style>

</style>
<style scoped>
.qr-scanner-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    background: black;
    display: flex;
}
.content {
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 12px;
    left: 12px;
    right: 12px;
    gap: 6px;
}
.content .abtn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;
    font-weight: 600;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    background-color: white;
    border: 1px solid transparent;
    font-size: 20px;
    line-height: 44px;
    border-radius: 0.25rem;
}
.qr-actions {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    gap: 6px;
    padding-bottom: 30px;
}
.qr-actions .abtn {
    flex: 1 0 auto;
    color: white;
    border: 2px solid white;
}
.qr-actions .abtn.positive {
    background: green;
}
.qr-actions .abtn.negative {
    background: red;
}

</style>
